import { computed } from 'vue';
import { useStore } from 'vuex';
import { ModuleManual } from '@/stores/moduleConst.js';

export const useManual = () => {
  const store = useStore();

  /**
   * Danh sách item hướng dẫn
   * @author: BMThang(03/04/2023)
   */
  const items = computed(() => {
    return store.state[ModuleManual].items;
  })

  /**
   * Số lượng item chưa xem
   * @author: BMThang(03/04/2023)
   */
  const unwatchItemAmount = computed(() => {
    return store.getters[`${ModuleManual}/unwatchItemAmount`];
  })

  /**
   * Có hiện floating btn ko
   * @author: BMThang(03/04/2023)
   */
  const isShowFloatingBtn = computed(() => {
    return store.getters[`${ModuleManual}/isShowFloatingBtn`];
  })

  /**
   * Hiện floating btn
   * @author: BMThang(03/04/2023)
   */
  const showFloatingBtn = () => {
    store.commit(`${ModuleManual}/showFloatingBtn`);
  }
  
  /**
   * Ẩn floating btn
   * @author: BMThang(03/04/2023)
   */
  const hideFloatingBtn = () => {
    store.commit(`${ModuleManual}/hideFloatingBtn`);
  }

  /**
   * Xét item với key đc truyền vào là đã xem
   * @param {string} itemKey Key của item
   * @author: BMThang(03/04/2023)
   */
  const setViewedItem = (itemKey) => {
    store.dispatch(`${ModuleManual}/setViewedItem`, itemKey);
  }
  
  /**
   * Reset các item đc xem
   * @param {string} itemKey Key của item
   * @author: BMThang(03/04/2023)
   */
  const resetViewedItems = () => {
    store.dispatch(`${ModuleManual}/resetViewedItems`);
  }

  return {
    items,
    unwatchItemAmount,
    isShowFloatingBtn,
    showFloatingBtn,
    hideFloatingBtn,
    setViewedItem,
    resetViewedItems,
  }
}